import { ChatMobileMenu } from '@app/components/ChatMobileMenu/ChatMobileMenu.main';

export { ChatMobileMenu };
